module.exports = __webpack_public_path__ + "static/media/ipsen.261c70ad.svg";